/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateStoreDto } from '../../models/create-store-dto';
import { StoreDto } from '../../models/store-dto';

export interface StoreControllerCreate$Params {
  /**
   * When true, auto-assigns the requesting user as an admin of the newly created store. Use for 3rd-party app install flows (e.g. Shopify) where the merchant should immediately manage the store.
   */
  assignCreatorAsAdmin?: boolean;

  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id'?: string;
  body: CreateStoreDto;
}

export function storeControllerCreate(
  http: HttpClient,
  rootUrl: string,
  params: StoreControllerCreate$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<StoreDto>> {
  const rb = new RequestBuilder(rootUrl, storeControllerCreate.PATH, 'post');
  if (params) {
    rb.query('assignCreatorAsAdmin', params.assignCreatorAsAdmin, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreDto>;
    })
  );
}

storeControllerCreate.PATH = '/api/v1/stores';
